import React, { useState } from 'react';
import OtpInput from 'react-otp-input';
import { Form, Button, Row, Col, Alert, Modal, Toast, ToastContainer } from 'react-bootstrap';
import QRCode from "react-qr-code";
import { useNavigate } from "react-router-dom";
import { configData } from "../config/systemconfigurationconstants";
import * as AWS from 'aws-sdk';
import { useEncryption } from '../customHooks/useEncryption';
const OtpVerification = (props) => {
    const { loginResponse, onClose } = props
    const [otp, setOtp] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showConfigureModal, setShowConfigureModal] = useState(false);
    const [showResetToaster, setShowResetToaster] = useState(false);
    const [showFailOTPToaster, setShowFailOTPToaster] = useState(false);
    const [showResetFailToaster, setShowResetFailToaster] = useState(false);
    const [scanQR, setScanQR] = useState('')

    const navigate = useNavigate();
    const { encrypt, decrypt } = useEncryption();
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return decodeURIComponent(parts.pop().split(';').shift());
        }
        return null;
    };
    const lambda = new AWS.Lambda({
        region: configData.LAMBDA_REGION,
        accessKeyId: decrypt(getCookie('ak')),
        secretAccessKey: decrypt(getCookie('sk'))
    });

    const getQRCode = () => {

        const data = {
            Command: "GENERATE_URL",
            AppName: "DG",
            SecurityToken: loginResponse.SecurityToken,
        };

        const params = {
            FunctionName: 'GoogleAuthenticatorHelperDGV2',
            Payload: JSON.stringify(data)
        };

        lambda.invoke(params, function (err, data) {
            if (err) {
                console.log(err);
            } else {
                console.log(JSON.parse(data.Payload.toString()))
                setScanQR(JSON.parse(data.Payload.toString()));
            }
        })
    }

    const handleChange = (newOtp) => {
        setOtp(newOtp);
    };

    const handleConfigureModalClose = () => {
        setShowConfigureModal(false);
    };

    const handleConfigure = () => {
        getQRCode()
        setShowConfigureModal(true);
    }

    const handleSubmit = (e) => {
        const data = {
            Command: "VALIDATE_OTP",
            SecurityToken: loginResponse.SecurityToken,
            AppName: "DG",
            OTP: otp
        };
        const params = {
            FunctionName: 'GoogleAuthenticatorHelper',
            Payload: JSON.stringify(data)
        };

        lambda.invoke(params, function (err, data) {
            if (err) {
                console.log(err);
            } else {
                let lambdaResponse = JSON.parse(data.Payload.toString());
                if (lambdaResponse === true) {
                    console.log('validate success')
                    navigate('/dashboard')
                }
                else {
                    console.log('validate fail')
                    setShowFailOTPToaster(true)
                    handleClear()
                }
            }
        });

        setIsSubmitting(false);
    };

    const handleClear = () => {
        setOtp('');
    };

    const handleResetAuthenticator = () => {
        const data = {
            Command: "RESET_GA_CODE",
            AppName: "DG",
            SecurityToken: loginResponse.SecurityToken,
            RequestedBy: loginResponse.UserName
        };

        const params = {
            FunctionName: 'GoogleAuthenticatorHelper',
            Payload: JSON.stringify(data)
        };

        lambda.invoke(params, function (err, data) {
            if (err) {
                console.log(err);
            } else {
                let lambdaResponse = JSON.parse(data.Payload.toString());
                if (lambdaResponse === true) {
                    setShowResetToaster(true)
                } else {
                    setShowResetFailToaster(true)
                }

            }
        });

        handleConfigure();
    };

    return (
        <div className="otp-verification-container">

            <Form>
                <Form.Text>OTP Verification</Form.Text>

                <Row>
                    <Col>
                        <OtpInput
                            value={otp}
                            onChange={handleChange}
                            numInputs={6}
                            inputStyle={{
                                width: "2.5rem",
                                height: "2.5em",
                                fontSize: "1rem",
                                borderRadius: "8px",
                                borderStyle: "solid",
                                borderColor: "#ced4da",
                            }}
                            containerStyle={{
                                justifyContent: "space-between",
                                margin: "3px 0",
                            }}
                            renderInput={(props) => <input {...props} />}
                            shouldAutoFocus
                        />
                        <Row style={{ marginTop: "1rem", marginBottom: "1rem" }}>
                            <Col style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Button onClick={handleSubmit} variant="secondary" size="sm" disabled={isSubmitting}>
                                    {isSubmitting ? 'Verifying...' : 'Verify OTP'}
                                </Button>
                                {/* <Button variant="primary" size="sm" disabled={isSubmitting}> */}
                                <Button variant='danger' onClick={handleClear} className="ri-delete-back-2-line"></Button>
                                {/* </Button> */}
                            </Col>
                        </Row>
                        <Row>
                            <Col style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Button style={{ width: "50px" }} variant="danger" size="sm" onClick={onClose}>Close</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col style={{ display: 'flex', justifyContent: 'end' }}>
                                <button className='btn btn-link btn-sm' type="button" onClick={handleConfigure}>
                                    Configure
                                </button>
                                <button className='btn btn-link btn-sm' type="button" onClick={handleResetAuthenticator}>
                                    Reset Authenticator
                                </button>
                            </Col>

                            <Modal show={showConfigureModal} onHide={handleConfigureModalClose}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Configure Modal</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div style={{ height: "auto", margin: "0 auto", maxWidth: 164, width: "100%" }}>
                                        <QRCode
                                            size={256}
                                            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                            value={scanQR}
                                            viewBox={`0 0 256 256`}
                                        />
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleConfigureModalClose}>
                                        Close
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <ToastContainer
                                className="p-3"
                                position={'bottom-center'}
                                style={{ zIndex: 1 }}
                            >
                                <Toast bg={"success"} autohide delay={4000} show={showResetToaster} onClose={() => setShowResetToaster(false)}>
                                    <Toast.Body className="text-white text-center">MFA Reset Succesfully</Toast.Body>
                                </Toast>
                                <Toast bg={"danger"} autohide delay={4000} show={showFailOTPToaster} onClose={() => setShowFailOTPToaster(false)}>
                                    <Toast.Body className="text-white text-center">OTP Verification Failed</Toast.Body>
                                </Toast>
                                <Toast bg={"danger"} autohide delay={4000} show={showResetFailToaster} onClose={() => setShowResetFailToaster(false)}>
                                    <Toast.Body className="text-white text-center">An error occurred while processing your request. Please refresh and try again.</Toast.Body>
                                </Toast>
                            </ToastContainer>
                        </Row>
                    </Col>
                </Row>


                {errorMessage && (
                    <Alert variant="danger">{errorMessage}</Alert>
                )}
            </Form>
        </div>
    );
};

export default OtpVerification;
